/* eslint-disable @typescript-eslint/default-param-last */
import { IProgressAction } from "@/types/progress.types";
import { UPDATE_PROGRESS } from "@/constants/ActionTypes";
import initialState from "@/store/initialState";

const progressReducer = (
  state = initialState.progress,
  action: IProgressAction,
) => {
  switch (action.type) {
    case UPDATE_PROGRESS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default progressReducer;
